import { UploadOutlined } from "@ant-design/icons";
import { Button, Form, Modal, Upload, message } from "antd";
import { useState } from "react";

export default function UploadContractModal({
  open,
  onSubmit,
  onCancel,
  isProcessing,
  restaurant,
}) {
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);

  const beforeUpload = (file) => {
    // Kiểm tra file type
    const isPDF = file.type === "application/pdf";
    if (!isPDF) {
      message.error("Chỉ chấp nhận file PDF!");
      return Upload.LIST_IGNORE;
    }

    // Kiểm tra file size (10MB = 10 * 1024 * 1024 bytes)
    const isLt10M = file.size / 1024 / 1024 < 10;
    if (!isLt10M) {
      message.error("File không được vượt quá 10MB!");
      return Upload.LIST_IGNORE;
    }

    setFileList([file]);
    return false; // Ngăn tự động upload
  };

  const handleRemove = () => {
    setFileList([]);
  };

  const handleSubmit = () => {
    if (fileList.length === 0) {
      message.error("Vui lòng chọn file hợp đồng!");
      return;
    }

    const formData = new FormData();
    formData.append("file", fileList[0]);

    onSubmit(restaurant._id, formData);
  };

  const handleCancel = () => {
    setFileList([]);
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title="Upload hợp đồng"
      okText="Upload"
      cancelText="Huỷ"
      centered
      open={open}
      onOk={handleSubmit}
      onCancel={handleCancel}
      confirmLoading={isProcessing}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label="Chọn file hợp đồng (PDF, tối đa 10MB)"
          required
          tooltip="Chỉ chấp nhận file PDF, kích thước tối đa 10MB"
        >
          <Upload
            beforeUpload={beforeUpload}
            onRemove={handleRemove}
            fileList={fileList}
            accept=".pdf,application/pdf"
            maxCount={1}
          >
            <Button icon={<UploadOutlined />}>Chọn file</Button>
          </Upload>
        </Form.Item>
        {restaurant && (
          <Form.Item label="Nhà hàng">
            <span>{restaurant.name || restaurant._id}</span>
          </Form.Item>
        )}
      </Form>
    </Modal>
  );
}
